import {
    ribbonMessage as ribbonMessage_1,
    yesRibbonButtonText,
    noRibbonButtonText,
    moreFeedbackRibbonMessage as moreFeedbackRibbonMessage_1,
    okRibbonButtonText,
    notNowRibbonButtonText,
    thankYouMessage as thankYouMessage_1,
} from './FeedbackRibbon.locstring.json';
import loc from 'owa-localize';
import * as React from 'react';
import { observer } from 'mobx-react';
import { Link } from 'office-ui-fabric-react/lib/Link';
import { ControlIcons } from 'owa-control-icons';
import { Icon } from 'office-ui-fabric-react/lib/Icon';
import { getGuid } from 'owa-guid';
import { setShowThankyouMessage } from '../mutators/setShowThankyouMessage';
import { setShowMoreFeedbackMessage } from '../mutators/setShowMoreFeedbackMessage';
import { setFeedbackRibbonResponse } from '../mutators/setFeedbackRibbonResponse';
import { resetFeedbackRibbonState } from '../mutators/resetFeedbackRibbonState';
import { initializeFeedbackRibbonState } from '../mutators/initializeFeedbackRibbonState';
import { logRibbonResponse } from '../actions/logRibbonResponse';
import { shouldShowIntermediateFeedbackRibbon } from '../utils/shouldShowIntermediateFeedbackRibbon';
import showInlineFeedbackDialog from './InlineFeedbackDialog';
import { FeedbackDialogParams } from './InlineFeedbackDialog';
import getFeedbackRibbonState from '../selectors/getFeedbackRibbonState';
import { YES, NO, OK, NOTNOW } from '../FeedbackConstants';
import { logRibbonResponseToAria } from '../utils/logRibbonResponseToAria';

const classNames = require('classnames');
let styles = require('./FeedbackRibbon.scss');

export interface FeedbackRibbonProps {
    feature: string;
    ribbonMessage?: string;
    thankYouMessage?: string;
    subFeature?: string;
    metadata?: string;
    yesCallBack?: () => void;
    noCallBack?: () => void;
    moreFeedbackRibbonMessage?: string;
    okCallBack?: () => void;
    notNowCallBack?: () => void;
    yesFeedbackDialogParams?: FeedbackDialogParams;
    noFeedbackDialogParams?: FeedbackDialogParams;
    ribbonMessageClassName?: string;
    hideRibbonIconDiv?: boolean;
    mockYesNoButtonClick?: string;
}

@observer
export default class FeedbackRibbon extends React.Component<FeedbackRibbonProps, {}> {
    sessionId: string;

    constructor(props: any) {
        super(props);
        this.sessionId = getGuid();
        initializeFeedbackRibbonState(this.sessionId);
        if (props.mockYesNoButtonClick) {
            this.ribbonButtonClickHandler(props.mockYesNoButtonClick);
        }
    }

    componentWillUnmount() {
        resetFeedbackRibbonState(this.sessionId);
    }

    render() {
        return (
            <div className={classNames(styles.RibbonMessage, this.props.ribbonMessageClassName)}>
                {!this.props.hideRibbonIconDiv && (
                    <div className={styles.RibbonIconDiv}>
                        <Icon iconName={ControlIcons.CommentUrgent} className={styles.RibbonIcon} />
                    </div>
                )}
                {!getFeedbackRibbonState(this.sessionId).showThankYouMessage &&
                    !getFeedbackRibbonState(this.sessionId).showMoreFeedbackMessage && (
                        <div>
                            <span className={styles.RibbonTitleMessage}>
                                {this.props.ribbonMessage || loc(ribbonMessage_1)}
                            </span>
                            <Link onClick={this.onYesClick} className={styles.ButtonLink}>
                                {loc(yesRibbonButtonText)}
                            </Link>
                            <Link onClick={this.onNoClick} className={styles.ButtonLink}>
                                {loc(noRibbonButtonText)}
                            </Link>
                        </div>
                    )}
                {getFeedbackRibbonState(this.sessionId).showMoreFeedbackMessage && (
                    <div>
                        <span className={styles.RibbonTitleMessage}>
                            {this.props.moreFeedbackRibbonMessage ||
                                loc(moreFeedbackRibbonMessage_1)}
                        </span>
                        <Link onClick={this.onOkClick} className={styles.ButtonLink}>
                            {loc(okRibbonButtonText)}
                        </Link>
                        <Link onClick={this.onNotNowClick} className={styles.ButtonLink}>
                            {loc(notNowRibbonButtonText)}
                        </Link>
                    </div>
                )}
                {getFeedbackRibbonState(this.sessionId).showThankYouMessage && (
                    <div>{this.props.thankYouMessage || loc(thankYouMessage_1)}</div>
                )}
            </div>
        );
    }

    private onYesClick = () => {
        this.ribbonButtonClickHandler(YES);

        if (this.props.yesCallBack) {
            this.props.yesCallBack();
        }
    };

    private onNoClick = () => {
        this.ribbonButtonClickHandler(NO);

        if (this.props.noCallBack) {
            this.props.noCallBack();
        }
    };

    private ribbonButtonClickHandler = (buttonClicked: string) => {
        setFeedbackRibbonResponse(buttonClicked, this.sessionId);

        logRibbonResponse({
            SessionId: this.sessionId,
            Feature: this.props.feature,
            RibbonResponse: buttonClicked,
            Metadata: this.props.metadata,
            SubFeature: this.props.subFeature,
        });

        logRibbonResponseToAria(
            this.sessionId,
            this.props.feature,
            this.props.subFeature,
            buttonClicked
        );

        let shouldShow: boolean =
            buttonClicked === YES
                ? shouldShowIntermediateFeedbackRibbon(this.props.yesFeedbackDialogParams)
                : shouldShowIntermediateFeedbackRibbon(this.props.noFeedbackDialogParams);
        if (shouldShow) {
            setShowMoreFeedbackMessage(true, this.sessionId);
        } else {
            setShowThankyouMessage(true, this.sessionId);
        }
    };

    private onOkClick = () => {
        this.intermediateRibbonButtonClickHandler(OK);

        if (this.props.okCallBack) {
            this.props.okCallBack();
        }

        if (getFeedbackRibbonState(this.sessionId).feedbackRibbonResponse === YES) {
            showInlineFeedbackDialog(this.props.yesFeedbackDialogParams, this.sessionId, YES);
        }
        if (getFeedbackRibbonState(this.sessionId).feedbackRibbonResponse === NO) {
            showInlineFeedbackDialog(this.props.noFeedbackDialogParams, this.sessionId, NO);
        }
    };

    private onNotNowClick = () => {
        this.intermediateRibbonButtonClickHandler(NOTNOW);

        if (this.props.notNowCallBack) {
            this.props.notNowCallBack();
        }
    };

    private intermediateRibbonButtonClickHandler = (buttonClicked: string) => {
        setShowThankyouMessage(true, this.sessionId);
        setShowMoreFeedbackMessage(false, this.sessionId);

        logRibbonResponse({
            SessionId: this.sessionId,
            Feature: this.props.feature,
            RibbonResponse: buttonClicked,
            SubFeature: this.props.subFeature,
        });
    };
}
